import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Blog from "../pages/blog/page";
import BlogArticle from "../pages/blog/article/page";
import KyoyuMeigi from "../pages/kyoyu-meigi/page";
import Nouchi from "../pages/nouchi/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "/kyoyu-meigi",
    element: <KyoyuMeigi />,
  },
  {
    path: "/nouchi",
    element: <Nouchi />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
